import { TextField } from "@mui/material";
import classNames from "classnames";
import React from "react";
import styles from "./CustomTextfield.module.scss";

interface CustomTextFieldProps {
  label?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: any) => void,
  className?: string;
  variant?: "filled" | "outlined" | "standard";
  type?: string;
  placeholder?: string;
  fullWidth?: boolean;
  InputProps?: any;
  inputRef?:any;
  style?:any;
}

const CustomTextField = ({
  label,
  value,
  onChange,
  className = "",
  variant = "outlined",
  type = "text",
  placeholder,
  fullWidth = false,
  InputProps,
  inputRef,
  style,
  onKeyDown,
  ...props
}: CustomTextFieldProps) => {
  const combinedClassName = classNames(styles.textFieldStyle, className);

  return (
    <TextField
      label={label}
      value={value}
      onChange={onChange}
      className={combinedClassName}
      variant={variant}
      type={type}
      placeholder={placeholder}
      fullWidth={fullWidth}
      InputProps={InputProps}
      onKeyDown={onKeyDown}
      style={style}
      inputRef={inputRef}
      {...props}
    />
  );
};

export default CustomTextField;
